import { withRouter } from 'react-router-dom';
import FaqAnswer from './FaqAnswer';

export default withRouter(FaqAnswer);
